import React, {Fragment} from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import { withRouter } from "react-router-dom";

import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

import {setLookActiveCategory, setLookActiveFeature, setLookOpened} from "../../../../../actions/lookFunctions";
import {getCategoryOnlyUrl} from "../../lookFunctions2";
import FeatureName from "../../../../visComponents/featureName";
import LookFeatureRevertButton from "./lookFeatureRevertButton";

const LookFeatureMobileHeader = (props) => {

  const {intl, lookActiveFeature, history, setLookActiveFeature, setLookActiveCategory} = props;

  const backButtonClick = () => {
    // setLookActiveFeature(null);
    setLookActiveFeature(null);
    setLookActiveCategory(lookActiveFeature.partId);
    history.push(getCategoryOnlyUrl(lookActiveFeature.partId));
  };

  return (
    <Fragment>
      <div className="lm-header__back">
        <IconButton aria-label={intl.formatMessage({id:"iconButton.back"})}
                    className={"look-icon look-icon--small"}
                    onClick={backButtonClick}>
          <ChevronLeftIcon/>
        </IconButton>
        <span className="lm-header__title" onClick={backButtonClick}>
          {lookActiveFeature ? <FeatureName feature={lookActiveFeature} useCollectionName={true}/> : null}
        </span>
      </div>
      <div className="lm-header__buttons">
        <LookFeatureRevertButton/>
      </div>
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveFeature, lookOpened, lookActiveCategory} = store.lookState;
  const {isMobile} = store.serverState;
  return {
    lookActiveCategory,
    isMobile,
    lookActiveFeature,
    lookOpened,
    activeFeatureId: lookActiveFeature ? lookActiveFeature.dbFeature.id : "",
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {
  setLookOpened,
  setLookActiveFeature,
  setLookActiveCategory,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookFeatureMobileHeader)
  )
)
